import React, { useState } from 'react';

import { Typography, List, ListItem, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';
import NestedList from '@hydra/common/components/Header/NestedList';
import menuItems from '@hydra/common/components/Header/menuItems';

import { useI18n } from '@hydra/common/customHooks';

import getTranslatedUrl, { UrlType } from '@hydra/utils/getTranslatedUrl';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(2, 2, 0, 2),
    height: 'calc(100% - 152px)',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  item: {
    padding: theme.spacing(2)
  },
  helpDropdownButton: {
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.primary
  }
}));

export default function NavigationDrawerContainer () {
  const classes = useStyles();
  const { locale } = useI18n();
  const [menuOpen, setMenuOpen] = useState<string | null>(null);

  return (
    <List className={classes.root} data-testid='navigation-drawer-container'>
      {
        menuItems.map((menu, index) => menu.group
          ? (
            <NestedList
              key={index}
              itemKey={JSON.stringify(menu)}
              menuOpen={menuOpen}
              setMenuOpen={setMenuOpen}
              contentColor='gray'
              menuItems={menu.items}
              menu={menu}
            />
            )
          : menu.link && (
            <ListItem key={index} button component={Link} className={classes.item} href={getTranslatedUrl(menu.link as UrlType, locale)}>
              <Typography noWrap className={classes.helpDropdownButton}>
                <Translate content={menu.label} />
              </Typography>
            </ListItem>
          )
        )
      }
    </List>
  );
}
